<script>
import { Doughnut } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.plugins.unregister(ChartDataLabels);
Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
  color: "#FFF"
});

export default {
  extends: Doughnut,
  props: ["data", "options", "refresh"],
  data() {
    return {
      defaultData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: true,
        datalabels: {
          display: false
        },
        hole: {
          display: false,
        },
        title: {
          display: true,
          text: "Donut Chart"
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            boxWidth: 12,
            display: true,
            fontSize: 10
          }
        },
        onClick: function(evt, item) {
          var activePoints = this.getElementsAtEvent(evt);
          var firstPoint = activePoints[0];
          console.log("donut click", evt, item, activePoints, firstPoint);
        }
      },
      chartData: null,
      chartOptions: null
    };
  },
  mounted() {
    this.render();
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.render();
        }
      }
    },
    options: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.render();
        }
      }
    }
  },
  methods: {
    async render() {
      if (this.data) {
        this.chartData = this.data;
      } else {
        this.chartData = this.defaultData;
      }
      if (this.options) {
        this.chartOptions = this.options;
      } else {
        this.chartOptions = this.defaultOptions;
      }
      if (this.chartOptions.datalabels.display == true) {
        this.addPlugin(ChartDataLabels);
      }

      if (this.chartOptions.hole.display == true) {

        this.addPlugin({
          id: "centertext",

          beforeDraw: function(chart) {
            //Get ctx from string

            var ctx = chart.chart.ctx;
            var fontStyle = "Arial";
            let sum = 0;

            if (chart.data.datasets.length > 0) {
              let dataArr = chart.data.datasets[0].data;
              dataArr.map(data => {
                sum += data;
              });
            }

            var color = "#6c757d"; //"#555";
            var fontSizeToUse = 14;
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";

            const centerX = chart.chart.width / 2; //Math.round((chart.chart.width - ctx.measureText(txt).width) / 2);
            let centerY = chart.chart.height / 2 + fontSizeToUse / 2;
            centerY += 3;
            if (chart.options.legend.display) {
              console.log("legend is", chart.options.legend.display);
              centerY += -10;
            }
            // const centerY = -10 + chart.chart.height / 2 + fontSizeToUse / 2;

            ctx.font = fontSizeToUse + "px " + fontStyle;
            ctx.fillStyle = color;

            var txt = "";

            if (sum == 0) {
              txt = "No data to display";
              fontSizeToUse = 12;
            } else {
              txt = sum;
              if (chart.options.hole.text) {
                txt = chart.options.hole.text
              }
            }
            ctx.fillText(txt, centerX, centerY);
          }
        });
      }
      this.renderChart(this.chartData, this.chartOptions);
    }
  }
};
</script>